<template>
  <div :class="{ 'has-portrait': portrait, 'has-title': true, 'has-description': description, 'surface-title': true }">
    <div ref="container" class="title-container" dir="auto">
      <processed-image
        v-if="portrait"
        id="portrait"
        :src="portrait"
        :transforms="{ preset: 'icon', width: 64, height: 64 }"
        v-t:alt="'Icon'"
      />
      <div class="title-text">
        <h1 class="title-heading" @dblclick="tryModify">{{ title || '&nbsp;' }}</h1>
        <h2
          v-if="description"
          class="title-description caption-type"
          @dblclick="tryModify"
          v-html="hyperlinkedDescription"
        />
        <surface-builder v-if="xBuilder" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import t from 'vuedirectives/t'
import SurfaceBuilder from 'vuecomponents/surface_builder'
import ProcessedImage from 'vuecomponents/processed_image'
import { mapGetters } from 'vuex'
import { link } from 'bits/autolinker'
export default {
  components: { SurfaceBuilder, ProcessedImage },
  directives: { t },
  watch: {
    title() {
      this.$emit('title-changed')
    },
    description() {
      this.$emit('description-changed')
    },
  },
  computed: {
    ...mapGetters(['portrait', 'title', 'description', 'canIAdminister']),
    xBuilder() {
      return !this.$store.state.isEmbedded
    },
    hyperlinkedDescription() {
      return link(this.description)
    },
  },
  methods: {
    tryModify() {
      if (this.canIAdminister) {
        this.$store.dispatch('settings/showSettingsPanel')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/3/modules/all';

.surface-title {
  position: relative;

  &.has-portrait .title-container {
    align-items: center;
  }

  .title-container {
    margin: 0;
    border: none;
    display: flex;
    box-sizing: border-box;
    align-items: flex-end;

    .title-text {
      display: flex;
      flex-direction: column;
      margin-right: 16px;

      h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
      }
      h2 {
        font-size: $body-font-size;
        line-height: 18px;

        a {
          color: inherit;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    #portrait {
      border-radius: $default-border-radius;
      margin: 0 16px 0 0;
    }
  }
}

.show .surface-title {
  .title-container {
    min-height: 84px;

    #portrait {
      max-height: 64px;
    }
  }

  &.has-title.has-description {
    .title-container {
      font-family: $sans-font-family;
      padding: 0 16px 16px 72px;

      @include respondToSmallHeader {
        padding: 8px 16px 12px;
      }
    }
  }

  &.has-title {
    .title-container {
      padding: 0 16px 20px 72px;

      @include respondToSmallHeader {
        padding: 8px 16px 12px;
      }
    }
  }

  &.has-title.has-portrait {
    .title-container {
      padding: 0 16px 16px;

      @include respondToSmallHeader {
        padding: 8px 16px 12px;
      }
    }
  }

  .surface-builder {
    order: -1;
  }

  @include respondToSmallHeader {
    .title-container {
      padding: 8px 16px;

      #portrait {
        max-height: 32px;
      }

      .title-text {
        h1 {
          font-size: 20px;
          line-height: 25px;
        }
      }

      .builder-avatar {
        display: none;
      }
    }
  }
}

.embed .surface-title {
  .title-container {
    min-height: 80px;

    #portrait {
      max-height: 48px;
    }
  }

  &.has-title.has-description {
    .title-container {
      padding: 16px 16px 16px 30px;
    }
  }

  &.has-title {
    .title-container {
      padding: 16px 16px 20px 30px;
    }
  }

  &.has-title.has-portrait {
    .title-container {
      padding: 16px 16px 16px 30px;
    }
  }
}
</style>
